import styled from 'styled-components';
import { PropertyCardBadge } from '../PropertyCardBadge/PropertyCardBadge';
export var StyledPhotoCarouselKeyboardInstructions = /*#__PURE__*/styled(PropertyCardBadge).withConfig({
  displayName: "StyledPhotoCarouselKeyboardInstructions",
  componentId: "c11n-8-111-1__sc-hcuerh-0"
})([""]);